import { Link } from 'react-router-dom';

export default function ConceptionLogoParis() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-orange-500 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xl">DC</span>
            </div>
            <span className="text-xl font-bold text-gray-900">DigiCreate</span>
          </Link>
          <a href="tel:+33123456789" className="bg-teal-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-teal-600 transition-all hover:scale-105 flex items-center gap-2 whitespace-nowrap">
            <i className="ri-phone-line text-lg"></i>
            Appeler
          </a>
        </div>
      </header>

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-black text-gray-900 mb-6 leading-tight">
            Conception de Logo Sur-Mesure à Paris
          </h1>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Studio de <strong>création d'identité visuelle</strong> et <strong>design de logo professionnel</strong> à Paris. Nous créons des logos uniques qui reflètent l'essence de votre marque avec une charte graphique complète.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a href="https://wa.me/33123456789?text=Bonjour,%20je%20souhaite%20obtenir%20des%20informations%20sur%20la%20conception%20de%20logo" className="bg-teal-500 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-teal-600 transition-all hover:scale-105 whitespace-nowrap">
              Demander un Devis Logo
            </a>
            <Link to="/" className="bg-gray-100 text-gray-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-200 transition-all whitespace-nowrap">
              Voir nos Créations
            </Link>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-black text-gray-900 mb-4 text-center">Services de Design Graphique</h2>
          <p className="text-lg text-gray-600 mb-12 text-center max-w-3xl mx-auto">
            De la <strong>création de logo vectoriel</strong> à la <strong>charte graphique complète</strong>, nous accompagnons votre marque dans son identité visuelle.
          </p>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-all">
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-palette-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Logo Professionnel</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                <strong>Conception de logo unique</strong> en format vectoriel, déclinable sur tous supports (print et web) avec plusieurs propositions créatives adaptées à votre secteur.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-1"></i>
                  <span>3 propositions de logo</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-1"></i>
                  <span>Fichiers vectoriels (AI, SVG, PDF)</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-1"></i>
                  <span>Déclinaisons couleurs et N&amp;B</span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-all">
              <div className="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-book-open-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Charte Graphique</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Création de votre <strong>identité visuelle complète</strong> avec palette de couleurs, typographies, règles d'utilisation et déclinaisons pour garantir la cohérence de votre marque.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-orange-500 mt-1"></i>
                  <span>Palette de couleurs personnalisée</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-orange-500 mt-1"></i>
                  <span>Choix typographique</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-orange-500 mt-1"></i>
                  <span>Guide d'utilisation PDF</span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-all">
              <div className="w-14 h-14 bg-purple-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-file-text-line text-3xl text-purple-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Supports de Communication</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Design de vos <strong>supports print et digitaux</strong> : cartes de visite, flyers, brochures, signatures email, posts réseaux sociaux avec votre nouvelle identité.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-purple-500 mt-1"></i>
                  <span>Cartes de visite</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-purple-500 mt-1"></i>
                  <span>Templates réseaux sociaux</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-purple-500 mt-1"></i>
                  <span>Papeterie d'entreprise</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-black text-gray-900 mb-4 text-center">Notre Processus Créatif</h2>
          <p className="text-lg text-gray-600 mb-12 text-center max-w-3xl mx-auto">
            Une approche structurée pour créer un <strong>logo professionnel</strong> qui marquera les esprits.
          </p>

          <div className="grid md:grid-cols-4 gap-6">
            {[
              { icon: 'ri-question-answer-line', title: 'Brief', desc: 'Échange sur vos valeurs et votre vision' },
              { icon: 'ri-search-eye-line', title: 'Recherche', desc: 'Analyse de votre secteur et concurrence' },
              { icon: 'ri-brush-line', title: 'Création', desc: 'Esquisses et propositions créatives' },
              { icon: 'ri-checkbox-circle-line', title: 'Finalisation', desc: 'Ajustements et livraison des fichiers' }
            ].map((step, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-orange-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <i className={`${step.icon} text-3xl text-white`}></i>
                </div>
                <div className="text-sm font-bold text-teal-500 mb-2">Étape {index + 1}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-br from-teal-500 to-orange-500">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl md:text-5xl font-black mb-6">Créons Votre Identité Visuelle</h2>
          <p className="text-xl mb-8 opacity-95">
            Contactez notre studio de design graphique à Paris pour donner vie à votre marque.
          </p>
          <a href="https://wa.me/33123456789?text=Bonjour,%20je%20souhaite%20obtenir%20un%20devis%20pour%20la%20conception%20de%20mon%20logo" className="inline-block bg-white text-teal-600 px-10 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all hover:scale-105 whitespace-nowrap">
            Demander un Devis Logo
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-gray-400 mb-4">© 2025 DigiCreate - Studio de Design Graphique à Paris</p>
          <div className="flex justify-center gap-6">
            <Link to="/" className="text-gray-400 hover:text-white transition-colors">Accueil</Link>
            <a href="mailto:contact@digicreate.fr" className="text-gray-400 hover:text-white transition-colors">Contact</a>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <a href="https://wa.me/33123456789?text=Bonjour,%20je%20souhaite%20obtenir%20des%20informations%20sur%20vos%20services%20digitaux" className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-all animate-bounce" aria-label="Contacter sur WhatsApp">
        <i className="ri-whatsapp-line text-3xl text-white"></i>
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full"></span>
      </a>
    </div>
  );
}
